<template>
  <div class="web-box-all">
    <div class="app-login-header">
      <div class="app-login-header-main">
        <div class="app-login-header-logo">
          <img src="@/assets/icon/logo.png"/>
        </div>
        <div class="app-login-header-info">
          <p>Franke Resuuply</p>
        </div>
      </div>
    </div>

    <div class="app-register-box">
      <div class="app-register-title">
        <p>Account cancellation</p>
      </div>
      <div class="app-register-from">
        <ul>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="account" value="" placeholder="Account"/>
                </b>
                </p>
            </li>
            <li style="width:100%; height:100px;"></li>
        </ul>
      </div>
      <div class="app-register-bottom">
        <p style="width:100%;" id="post_data" @click="post_data()">Submit</p>
      </div>
    </div>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>
  </div>

</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import $ from 'jquery'
import address from '@/utils/address.json'
import Toast from '@/components/toast/index'

export default {
  name: 'register',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '注册',
      account: '',
      toast_state: 'display:none',
      toast_text: '',
      isMobile: false
    }
  },
  created () {
  // 省份数据初始化
    this.addressData = address
  },
  unmounted () {
    window.removeEventListener('resize', this.updateIsMobile())
  },
  mounted () {
    window.removeEventListener('resize', this.updateIsMobile())

    localStorage.setItem('accessToken', '')
    $('#login_type').val(['2'])

    localStorage.setItem('store_info', '')

    this.main_height = $(window).height() - 180
  },
  methods: {
    updateIsMobile () {
      this.isMobile = window.innerWidth < 768
    },
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    verify_post (type) {
      if (type === true) {
        $('#post_data').css({'background': '#cccccc'})
      } else {
        $('#post_data').css({'background': '#d81e06'})
      }
    },
    set_login () {
      this.$router.push('/login')
    },
    post_data () {
      var that = this

      let account = this.account
      if (account === '') {
        that.toast('Please enter the account number')
        return
      }

      that.toast('Submitted successfully, please wait for customer service to contact you.')
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}

.web-login-header { width:100%; height:100px;}
  .web-login-header-main { width:1000px; height:100px; margin:0px auto; flex-flow:row; justify-content:space-between;}
    .web-login-header-logo { width:auto; height:70px; margin-top:15px;}
      .web-login-header-logo img { width:auto; height:70px;}
    .web-login-header-info { width:auto; height:100px;}
      .web-login-header-info p { width:auto; height:30px; line-height: 30px; font-size:16px; color:#666666; margin-top:45px;}

.ext-footer-box { width:100%; height:auto;}
.ext-footer-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
    .ext-footer-link { width:100%; height:30px; padding:0px 30px; margin-top:10px; }
        .ext-footer-link p { width:100%; height:40px; line-height:40px; margin:0px; flex-flow:row; justify-content:center;align-content:center;}
        .ext-footer-link p a { width:auto; height:40px; cursor: pointer; position: relative; line-height:40px; padding:0px 10px; font-size:12px; color:#666666;}
        .ext-footer-link p a i { width:1px; height:12px; position:absolute; top:15px; left:0px; border-right: 1px solid #cccccc; }
        .ext-footer-link p a:hover  { color:#d81e06;}
    .ext-footer-copy { width:100%; height:20px;margin-top:20px;flex-wrap:wrap; align-content:flex-start;}
        .ext-footer-copy ul { width:100%; height:24px; list-style: none; line-height:24px; flex-flow:row; justify-content:center; margin:0px;}
        .ext-footer-copy ul li { width:auto; height:24px; font-weight: normal; position: relative; line-height:24px; padding:0px 10px; font-size:12px; color:#666666;}
        .ext-footer-copy ul li i { width:1px; height:12px; position:absolute; top:3px; left:0px; border-right: 1px solid #cccccc; }
        .ext-footer-copy ul li a { color:#666666; cursor: pointer;}
        .ext-footer-copy ul li a:hover  { color:#d81e06;}

.web-login-banner { width:100%; height:475px; background: #d81e06;
min-height:475px;
width: 100%;
background-image: url(https://parts.franke.cn/lemon_pro/static/svg/svg.svg);
background-repeat: no-repeat;
background-position: 50%;
background-size: 90%;
height: 475px;
overflow: hidden;

}
  .web-login-banner-main { width:1000px; height:auto; margin:0px auto; position: relative;}
  .web-login-form { width:1000px; height:460px; display: flex; flex-wrap:wrap; align-content:flex-start;  position:absolute;top:35px; left:0px; background: #ffffff;}

  .web-login-form-data { width:100%; height:auto; float:left; display: flex; flex-flow:row; align-content:flex-start;  }
  .web-login-form-left { width:100%; height:auto; float:left; flex-wrap:wrap; align-content:flex-start; }
  .web-login-form h2 { width:100%; height:55px; margin-top:0px; border-bottom: 1px solid #f4f4f4;}
    .web-login-form h2 a { width:50%; height:50px; line-height:50px; padding-left:15px; font-size:18px; color:#333333;}
    .web-login-form h2 a.select { color:#d81e06; font-weight: bold;}
    .web-login-form-left ul { width:100%; height:auto; padding:0px 20px; margin-top:10px; flex-wrap:wrap; align-content:flex-start;}
    .web-login-form-left ul li { width:33%; height:45px; margin-top:20px; padding-right:30px;}
    .web-login-form-left ul li p { width:100%; height:45px; overflow: hidden; border: 1px solid #bdbdbd; border-radius: 4px; display: flex; flex-flow:row; justify-content:flex-start; }
    .web-login-form-left ul li p a { width:40px; height:45px;}
    .web-login-form-left ul li p a img { width:16px; height:16px; margin:14px 0px 0px 12px;}
    .web-login-form-left ul li p b { width:248px; height:45px; display: flex; flex-flow:row; justify-content:flex-start;}
    .web-login-form-left ul li p b input { width:240px; height:30px; margin-top:6px; border:0px; min-height:30px; margin-left:0px; font-size:14px; line-height: 30px; color:#333333;}
    .web-login-form-left ul li p b select { width:100px !important; height:45px; float:left; border:0px; font-size:14px;border:none;outline:0;outline:none !important; margin-top:-2px; margin-left:-6px; box-sizing:border-box;}
    .web-login-form-left ul li p b select:focus{ border-color:#fff; -webkit-box-shadow:none; box-shadow:none;}
    .web-login-form-left ul li p b select option { width:100px; height:45px;}
    .web-login-form-left ul li h3 { width:100%; height:20px; justify-content:flex-end;}
    .web-login-form-left ul li h3 a { width:100px; height:20px; cursor: pointer; line-height:20px; text-align: right; justify-content:flex-end; font-size:12px; color:#333333;}

    .web-login-form-left ul li h4 { width:100%; height:45px; cursor: pointer; line-height:45px; font-size:18px; background: #d81e06; color:#ffffff; border-radius: 4px; text-align: center; justify-content:center; }

    .web-login-banner-img { width:100%; height:80vh; position:absolute; top:100px; left:0px;}
.web-login-banner-img img { width:100%; height:100%;object-fit: cover;}

.app-login-header { width:100%; height:60px;}
  .app-login-header-main { width:100%; height:50px; margin:0px auto; padding:0px 15px; flex-flow:row; justify-content:space-between;}
    .app-login-header-logo { width:auto; height:35px; margin-top:15px;}
      .app-login-header-logo img { width:auto; height:35px;}
    .app-login-header-info { width:auto; height:50px;}
      .app-login-header-info p { width:auto; height:30px; line-height: 30px; font-size:12px; color:#666666; margin-top:25px;}

.app-register-box { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
  .app-register-title { width:100%; height:40px; padding:0px 15px;}
  .app-register-title p { width:100%; height:40px; line-height: 40px; font-size:14px; color:#d81e06; font-weight: bold;}
  .app-register-from { width:100%; height:auto;}
    .app-register-from ul { width:100%; height:auto; padding:0px 20px; margin-top:10px; flex-wrap:wrap; align-content:flex-start;}
    .app-register-from li { width:100%; height:45px; margin-top:20px; padding-right:30px;}
    .app-register-from ul li p { width:100%; height:45px; overflow: hidden; border: 1px solid #bdbdbd; border-radius: 4px; display: flex; flex-flow:row; justify-content:flex-start; }
    .app-register-from ul li p a { width:40px; height:45px;}
    .app-register-from ul li p a img { width:16px; height:16px; margin:14px 0px 0px 12px;}
    .app-register-from ul li p b { width:248px; height:45px; display: flex; flex-flow:row; justify-content:flex-start;}
    .app-register-from ul li p b input { width:240px; height:30px; margin-top:6px; border:0px; min-height:30px; margin-left:0px; font-size:14px; line-height: 30px; color:#333333;}
    .app-register-from ul li p b select { width:100px !important; height:45px; float:left; border:0px; font-size:14px;border:none;outline:0;outline:none !important; margin-top:-2px; margin-left:-6px; box-sizing:border-box;}
    .app-register-fromt ul li p b select:focus{ border-color:#fff; -webkit-box-shadow:none; box-shadow:none;}
    .app-register-from ul li p b select option { width:100px; height:45px;}
    .app-register-from ul li h3 { width:100%; height:20px; justify-content:flex-end;}
    .app-register-from ul li h3 a { width:100px; height:20px; cursor: pointer; line-height:20px; text-align: right; justify-content:flex-end; font-size:12px; color:#333333;}

  .app-register-bottom { width:100%; height:70px; position: fixed; padding:10px 50px;display: flex; flex-flow:row; justify-content: space-between ;border-top:1px solid #efefef; bottom:0px; left:0px; background: #ffffff;}
  .app-register-bottom p { width:100%; height:40px; line-height: 40px; text-align: center; justify-content:center; font-size:15px; color: #ffffff; background: #d81e06;}
</style>



// WEBPACK FOOTER //
// src/pages/public/check_user.vue